import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Observable, from } from 'rxjs';

import { AuthenticationService } from '../authentication.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HttpHeaderInterceptor implements HttpInterceptor{

  constructor(
    private _authService: AuthenticationService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.startsWith(environment.apiRoot)){
      return from(this._authService.getAccessToken()
        .then(token => {
          const headers = new HttpHeaders().set("Authorization", `Bearer ${token}`);
          const requestWithAuthHeader = req.clone({headers});
          return next.handle(requestWithAuthHeader).toPromise();
        }));
    }else{
      return next.handle(req);
    }
  }
}
